namespace $.$$ {

	export class $shm_hitalama_map_widget_float_circle extends $.$shm_hitalama_map_widget_float_circle {

		content_pointerdown( event: PointerEvent ) {
			return $.$$.$shm_hitalama_map_widget_float.prototype.content_pointerdown.call( this, event )
		}

		fill() {
			return this.background_style()
		}

		stroke() {
			return this.border_color_style() || 'transparent'
		}

		stroke_width() {
			return String( this.widget().border_width() )
		}

	}

}
